Namespace 'Monitoring.Reports.Publications.Sections'

class Monitoring.Reports.Publications.Subsections.ThematicsView extends Backbone.View

  template: JST['backbone/templates/monitoring/reports/publications/content/subsections/thematics']

  initialize: (@options = {}, @header, @model) ->

    @model.bind('thematicsFetched', @fill)
    # just set @options

  render: ->
    @$el.html(@template(@options))
    return this

  fill: (thematic) =>
    data = thematic.getPrintableData()
    bar_chart_view = new Monitoring.Views.Charts.CountBarsChartView(data, "Thematics")
    @$('#thematics-container').append(bar_chart_view.el)